import { render, staticRenderFns } from "./glbUpload.vue?vue&type=template&id=7813be24&scoped=true"
import script from "./glbUpload.vue?vue&type=script&lang=js"
export * from "./glbUpload.vue?vue&type=script&lang=js"
import style0 from "./glbUpload.vue?vue&type=style&index=0&id=7813be24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7813be24",
  null
  
)

export default component.exports